import { SnackbarProvider as NotistackProvider } from 'notistack';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Grow } from '@mui/material';
import {
  forwardRef, useState,
} from 'react';
import { createPortal } from 'react-dom';

const StyledSnackbarProvider = styled(NotistackProvider)`
  ${({ theme }) => `
    &.SnackbarItem-contentRoot {
      background-color: ${theme.palette.grey[5]};
      color: ${theme.palette.grey[100]};
      svg {
        color: ${theme.palette.success.main};
      }
    }
    &.SnackbarItem-variantError svg {
      color: ${theme.palette.error[100]};
    }
  `}
`;

const notistackRoot = document.getElementById('notistackHelper');

const AlertContainer = forwardRef((props, ref) => (
  <>
    {createPortal(
      <div css={css`position: absolute;`} ref={ref} />,
      notistackRoot,
    )}
  </>
));

export const SnackbarProvider = ({ children }) => {
  const [alertContainer, setAlertContainer] = useState(null);
  return (
    <>
      <AlertContainer ref={setAlertContainer} />
      <StyledSnackbarProvider
        domRoot={alertContainer}
        maxSnack={5}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        TransitionComponent={Grow}
      >
        {children}
      </StyledSnackbarProvider>
    </>
  );
};

SnackbarProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
